import React from 'react';

const TextArea = ({ ...props }) => {
  return (
    <textarea
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400
        focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
      {...props}
    />
  );
};

export default TextArea;